import _ from 'lodash';
import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';
import ListView from '../list/ListView';
import { modal } from '../modal/ModalEmitter';
import Form from '../form/Form';

class QueryListContainer extends Component {
  constructor(props) {
    super(props);

    this.listView = createRef();
    const columnDefs = props.headers.map(header => {
      if (
        header.type &&
        _.intersection(typeof header.type === 'string' ? [header.type] : header.type, [
          'number',
          'currencyColumn',
          'numberColumn',
          'integer',
        ]).length
      ) {
        header.filter = 'agNumberColumnFilter';
      }

      return { headerName: header.label, field: header.name, filter: header.filter };
    });

    this.state = {
      columnDefs,
      rowData: [],
      ready: false,
      filter: props.filter || [],
      filterParams: null,
    };
  }

  componentDidMount() {
    this.refresh();
  }

  handleFilter = () => {
    modal.open('info', {
      title: 'Filter',
      style: '',
      hidePrint: true,
      hideFooter: true,
      headerClass: 'primary',
      message: (
        <Form
          layout={this.state.filter}
          exportFormat="object"
          onCancel={modal.close}
          submit={this.handleFilterSubmit}
        />
      ),
    });
  };

  handleFilterSubmit = data => {
    modal.close();
    const filter = this.state.filter.map(field => {
      field.data = data[field.name];
      return field;
    });
    this.setState({ filterParams: data, filter }, () =>
      this.refresh().then(() => this.listView.current.agGrid.api.refreshInfiniteCache())
    );
  };

  processRow(row) {
    const { headers } = this.props;

    const obj = {};
    for (const header of headers) {
      if (header.type && header.type === 'datetime') {
        obj[header.name] = row[header.name].value;
      } else {
        obj[header.name] = row[header.name];
      }
    }

    return obj;
  }

  refresh = (params = {}) => {
    const { filterParams } = this.state;

    if (filterParams) {
      params.filter = btoa(JSON.stringify(filterParams));
    }

    return Api.get(`query/${this.props.name}`, { params }).then(response => {
      response.data.list = response.data.list.map(row => this.processRow(row));
      return Promise.resolve(response);
    });
  };

  render() {
    const { columnDefs } = this.state;

    return (
      <ListView
        ref={this.listView}
        canAdd={false}
        showRowToolbar={false}
        columnDefs={columnDefs}
        handleFilter={this.props.filter ? this.handleFilter : null}
        handleRefresh={this.refresh}
        itemName={this.props.name}
        namespace="query"
        rowData={[]}
        getData={this.refresh}
        serverSide={this.props.serverSide}
      />
    );
  }
}

QueryListContainer.propTypes = {
  name: PropTypes.string,
  headers: PropTypes.array,
  filter: PropTypes.array,
  serverSide: PropTypes.bool,
};

export default QueryListContainer;
